// extracted by mini-css-extract-plugin
export default {"pageWrapper":"CreateFormPage_pageWrapper__EWamh"};